module.exports = __webpack_public_path__ + "static/easy-cd62565914274c60d51f139d9c43afa2.mp4";